import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import List from "../Components/DistributorNetwork/List";
import Add from "../Components/DistributorNetwork/Add";
import Godown from "../Pages/Godown";
import { useLocation } from "react-router-dom";
import View from "../Components/DistributorNetwork/View";
import { last } from "lodash";
import Target from "../Pages/Target";
import Close from "../Components/DistributorNetwork/Close";
import ScanView from "../Components/DistributorNetwork/ScanView";
import TransactionDetail from "../Components/DistributorNetwork/TransactionDetail";
import Listing from "../Components/DistributorNetwork/Orders/Listing";
import Detail from "../Components/DistributorNetwork/Orders/Detail";

function DistributorNetwork() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const lastWord = pathParts[pathParts.length - 1];
  const [heading, setHeading] = useState("");
  const [orderDetail, setOrderDetail] = useState({});
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    city: "",
    state: "",
    district: "",
    companyName: "",
    assignSp: "",
  });

  useEffect(() => {
    if (!rowData) {
      setComp("list");
      setFilters({
        city: "",
        state: "",
        district: "",
        companyName: "",
        assignSp: "",
      });
      setPage(1);
    }
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  useEffect(() => {
    let vendorType = "";
    if (lastWord === "distributor") vendorType = "Distributor";
    else if (lastWord === "dealer") vendorType = "Dealer";
    else if (lastWord === "retailer") vendorType = "Retailer";
    else if (lastWord === "key-accounts") vendorType = "Key Accounts";
    else if (lastWord === "pro") vendorType = "PRO";

    setHeading(vendorType);
  }, [lastWord]);

  console.log(page);
  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>{heading}</h1>
          </div>

          {comp === "list" ? (
            <List
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
              heading={heading}
              page={page}
              setPage={setPage}
              filters={filters}
              setFilters={setFilters}
            />
          ) : comp === "view" ? (
            <View
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
              heading={heading}
            />
          ) : comp === "godown" ? (
            <Godown
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
            />
          ) : comp === "target" ? (
            <Target
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
            />
          ) : comp === "close" ? (
            <Close
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
            />
          ) : comp === "scan" ? (
            <ScanView
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
            />
          ) : comp === "transaction" ? (
            <TransactionDetail
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
            />
          ) : comp === "orderListing" ? (
            <Listing
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
              heading={heading}
              setOrderDetail={setOrderDetail}
            />
          ) : comp === "orderDetail" ? (
            <Detail
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
              currentComp={lastWord}
              heading={heading}
              orderDetail={orderDetail}
            />
          ) : (
            <Add
              comp={comp}
              rowData={rowData}
              onChange={handleChange}
              currentComp={lastWord}
            />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default DistributorNetwork;
